import { ComponentTokens, DesignToken, getComponentToken } from '@optimus-web/common';
import { LinkProps, LinkState, LinkVariant } from './types';

const getLinkState = ({ variant = 'default', disabled, inherit, standalone }: LinkProps) => {
    let state = LinkState.Inline;

    if (disabled) {
        state = LinkState.Disabled;
    } else if (inherit) {
        state = LinkState.Inherit;
    } else if (standalone) {
        state = LinkState.Standalone;
    }

    return { variant, state };
};

const tokens = {
    color: {
        default: {
            basic: {
                disabled: 'textDisabled',
                inherit: 'inherit',
                standalone: 'textInteractiveSecondaryDefault',
                inline: 'textInteractiveSecondaryDefault',
            },
            default: {
                disabled: 'textDisabled',
                inherit: 'inherit',
                standalone: 'textInteractivePrimaryDefault',
                inline: 'textInteractivePrimaryDefault',
            },
        },
        hover: {
            basic: {
                disabled: 'textDisabled',
                inherit: 'inherit',
                standalone: 'textInteractiveSecondaryHover',
                inline: 'textInteractiveSecondaryHover',
            },
            default: {
                disabled: 'textDisabled',
                inherit: 'inherit',
                standalone: 'textInteractivePrimaryHover',
                inline: 'textInteractivePrimaryHover',
            },
        },
        active: {
            basic: {
                disabled: 'textDisabled',
                inherit: 'inherit',
                standalone: 'textInteractiveSecondaryActive',
                inline: 'textInteractiveSecondaryActive',
            },
            default: {
                disabled: 'textDisabled',
                inherit: 'inherit',
                standalone: 'textInteractivePrimaryActive',
                inline: 'textInteractivePrimaryActive',
            },
        },
    },
} satisfies ComponentTokens<LinkVariant, LinkState, DesignToken | 'inherit'>;

export const getLinkToken = getComponentToken(tokens, getLinkState);
